import React from "react";
import { Col } from "react-bootstrap";

function TitleComp(props) {
  return (
    <>
      <Col md="12">
        <div className="text-center textgradientheading">
          <h4 className="jost">{props.title}</h4>
        </div>
      </Col>
    </>
  );
}

export default TitleComp;
